export default "/images/vendor/flag-icon-css/flags/1x1/hk.svg?99b41311a509aca54f06072e7d7fe662";